"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EntitySelect = exports.EntitySelectDefaultProps = exports.entitySelectDefaultTransform = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var client_1 = require("@apollo/client");
var select_1 = require("../elements/select");
var entity_select_option_1 = require("./entity-select-option");
var entity_select_value_1 = require("./entity-select-value");
var entity_select_multi_value_1 = require("./entity-select-multi-value");
var sprintf_js_1 = require("sprintf-js");
var use_icons_1 = require("../../hooks/use-icons");
var menu_context_1 = require("../context/menu-context");
var select_context_1 = require("../context/select-context");
var window_size_1 = require("@react-hook/window-size");
var entitySelectDefaultTransform = function (entity) {
  return {
    value: entity.id,
    label: entity._optionLabel || entity.name,
    entity: entity
  };
};
exports.entitySelectDefaultTransform = entitySelectDefaultTransform;
exports.EntitySelectDefaultProps = {
  debounceInterval: 250,
  pageSize: 50,
  loadOptionsOnMenuOpen: true,
  defaultOptions: true,
  isSearchable: true,
  isClearable: true,
  transform: exports.entitySelectDefaultTransform
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    button.ellipsis-button {\n      visibility: hidden !important;\n    }\n\n    .shp--input-select__placeholder {\n      cursor: text;\n    }\n\n    .shp--entity-select__placeholder {\n      cursor: text;\n    }\n\n    &:hover {\n      ", "\n    }\n  "], ["\n    button.ellipsis-button {\n      visibility: hidden !important;\n    }\n\n    .shp--input-select__placeholder {\n      cursor: text;\n    }\n\n    .shp--entity-select__placeholder {\n      cursor: text;\n    }\n\n    &:hover {\n      ", "\n    }\n  "])), function (props) {
    return props.showEditMenu && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        button.ellipsis-button {\n          visibility: visible !important;\n        }\n      "], ["\n        button.ellipsis-button {\n          visibility: visible !important;\n        }\n      "])));
  })
});
var SingleValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding-left: 1px;\n  "], ["\n    padding-left: 1px;\n  "])))
});
var MultiValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  "], ["\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(select_1.Select)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  SingleValue: (0, styled_components_1.default)(entity_select_value_1.EntitySelectValue)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SingleValueStyles),
  MultiValue: (0, styled_components_1.default)(entity_select_multi_value_1.EntitySelectMultiValue)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), MultiValueStyles)
};
var EntitySelect = function (props) {
  var className = props.className,
    entityTypeName = props.entityTypeName,
    debounceInterval = props.debounceInterval,
    pageSize = props.pageSize,
    isMulti = props.isMulti,
    transform = props.transform,
    showEditMenu = props.showEditMenu,
    selectProps = __rest(props, ["className", "entityTypeName", "debounceInterval", "pageSize", "isMulti", "transform", "showEditMenu"]);
  var client = (0, client_1.useApolloClient)();
  var defn = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var select = defn.select;
  var Icons = (0, use_icons_1.useIcons)();
  var Icon = Icons.Entities[defn.name] || Icons.SearchCircle;
  var searchIconSize = isMulti ? 36 : 48;
  var loadOptions = function (inputValue, prevOptions) {
    return __awaiter(void 0, void 0, void 0, function () {
      var loadOptionsFilter, filter, data, listResults, _a, results, meta, options, allOptions;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            loadOptionsFilter = props.loadOptionsFilter || select.loadOptionsFilter;
            filter = loadOptionsFilter(inputValue);
            return [4 /*yield*/, client.query({
              query: select.query,
              variables: {
                limit: pageSize,
                orderBy: select.orderBy,
                skip: prevOptions.length,
                filter: filter
              }
            })];
          case 1:
            data = _b.sent().data;
            listResults = data[select.queryName] || {
              results: [],
              meta: {
                count: 0,
                total: 0
              }
            };
            _a = listResults.results, results = _a === void 0 ? [] : _a, meta = listResults.meta;
            options = results.map(transform) || [];
            allOptions = __spreadArray(__spreadArray([], __read(prevOptions || []), false), __read(options), false);
            return [2 /*return*/, {
              hasMore: allOptions.length < meta.total,
              options: options
            }];
        }
      });
    });
  };
  var ref = react_1.default.useRef();
  var components = {
    Option: entity_select_option_1.EntitySelectOptionWithDescriptions,
    Value: entity_select_value_1.EntitySelectValue,
    SingleValue: entity_select_value_1.EntitySelectSingleValue,
    MultiValue: entity_select_multi_value_1.EntitySelectMultiValue
  };
  var windowWidth = (0, window_size_1.useWindowWidth)();
  var isSearchable = true; // windowWidth < 768 ? false : props.isSearchable;
  var styles = (0, react_1.useMemo)(function () {
    return __assign(__assign({}, props.styles), {
      menuPortal: function (base, state) {
        return __assign(__assign({}, base), {
          zIndex: 9999,
          position: 'fixed'
        });
      }
    });
  }, []);
  var placeholder = isMulti ? (0, sprintf_js_1.sprintf)('Select one or more %s...', defn.pluralLabel) : (0, sprintf_js_1.sprintf)('Select %s...', defn.aLabel);
  var portal = (0, select_context_1.useSelectContext)().portal;
  return react_1.default.createElement(menu_context_1.MenuProvider, {
    value: {
      portal: ref,
      preventEdit: !showEditMenu,
      preventDelete: true
    }
  }, react_1.default.createElement("div", {
    ref: ref
  }, react_1.default.createElement(My.Container, __assign({}, selectProps, {
    showEditMenu: true,
    isSearchable: isSearchable,
    styles: styles,
    classNamePrefix: 'shp--entity-select',
    searchIconColor: "text-subtle",
    searchIcon: react_1.default.createElement(Icon, null),
    searchIconSize: searchIconSize,
    loadOptions: loadOptions,
    className: className,
    isMulti: isMulti,
    menuPortalTarget: portal && portal.current,
    components: components,
    placeholder: placeholder,
    padOptions: false
  }))));
};
exports.EntitySelect = EntitySelect;
exports.EntitySelect.defaultProps = exports.EntitySelectDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;